import React, {FC, ReactNode} from 'react';
import {DownOutlined} from '@ant-design/icons';
import {Dropdown, DropdownProps} from 'antd';
import {Only} from '@joyrideautos/ui-common/src/components/Only';

export type DropdownMenuItem = {
    id: string;
    label: ReactNode;
    onClick: () => void;
};

interface DropdownMenuProps extends DropdownProps {
    title?: string;
    icon?: React.ReactNode;
    items: DropdownMenuItem[];
}

export const DropdownMenu: FC<DropdownMenuProps> = ({title, icon, items, ...rest}) => {
    return (
        <Dropdown
            {...rest}
            menu={{
                items: items.map(({id, label, onClick}) => ({
                    label,
                    key: id,
                    onClick,
                })),
            }}>
            <span className="ant-dropdown-link">
                {icon ?? null}
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a>
                    <Only when={!!title}>
                        {title}
                        <span className="ant-dropdown-link">
                            <DownOutlined style={{fontSize: 12}} />
                        </span>
                    </Only>
                </a>
            </span>
        </Dropdown>
    );
};
